import clsx from "clsx";
import { type FC } from "react";

import {
  COURSE_CODE_GROUPING_ID_QUERY_PARAM,
  COURSE_CODE_ID_QUERY_PARAM,
} from "components/constants";
import { CourseCodeType } from "components/server-types";
import { DragAndDrop, DraggableItemType } from "mds/components/DragAndDrop";
import { ListItem } from "mds/components/ListItem";
import { useQueryParamsManager } from "utils/routing";
import { withQueryParams } from "utils/urls";

const COURSE_CODE_EVENT_PREFIX = "Home - Course Catalog / ";

type CourseCodeNavListItemProps = {
  className?: string;
  courseCode: CourseCodeType;
  isSelected: boolean;
  dropIndex?: number;
  onDropItem?: (item: CourseCodeType) => void;
  onMoveLocally?: (item: DraggableItemType, toIndex: number, dropContainerId: string) => void;
};

export const CourseCodeNavListItem: FC<CourseCodeNavListItemProps> = ({
  courseCode,
  className,
  isSelected,
  dropIndex,
  onDropItem,
  onMoveLocally,
}) => {
  const { setQueryParams } = useQueryParamsManager();

  return (
    <DragAndDrop
      // draggable={canEdit}
      dragItemKind="course_code"
      dropContainerId="course_code"
      dropIndex={dropIndex}
      // droppable={canEdit}
      item={courseCode}
      onDraggedItemHover={onMoveLocally}
      onDropItem={onDropItem}
    >
      <ListItem
        className={clsx("my-1 min-w-12 justify-between", className)}
        eventName={`${COURSE_CODE_EVENT_PREFIX}course code selected`}
        eventProperties={{ courseCode: courseCode.title }}
        isSelected={isSelected}
        label={courseCode.title}
        to={withQueryParams("", {
          [COURSE_CODE_ID_QUERY_PARAM]: courseCode.id,
          [COURSE_CODE_GROUPING_ID_QUERY_PARAM]: null,
        })}
        onClick={() => {
          setQueryParams({
            [COURSE_CODE_ID_QUERY_PARAM]: courseCode.id,
            [COURSE_CODE_GROUPING_ID_QUERY_PARAM]: null,
          });
        }}
      >
        <div className="flex w-full min-w-12 items-center justify-between">
          <h3 className="body-s my-1 w-full min-w-12 cursor-pointer truncate font-medium">
            {courseCode.title}
          </h3>
        </div>
      </ListItem>
    </DragAndDrop>
  );
};
